import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

export let startSymphonyServices = data => {
  const root = createRoot(document.getElementById('symphony_services'))
  root.render(
    <App
      assessmentDelivery={Boolean(data.assessment_delivery)}
      symphonyData={data.symphony_data}
    />
  )
}
